import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/user/getPermisos.php';

export default function getPermisos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}